// A lift's warm-up setup as words a person can read, paste into a message, and
// set up again by hand: the start, every step and what it is a share of, the
// last jump, and the weights they make today.
//
// Pure — no store, no plugins — so the Warm-ups screen shares exactly what it
// shows and the test can read it back.
import { fmt, rangeTo, jumpRule } from './loading.js';

/** "5", or "1–2" for a range. */
const times = (reps, to) => {
  const n = Number(reps) || 1;
  const t = rangeTo(n, to);
  return t ? `${n}–${t}` : `${n}`;
};

/**
 * @param {object} o
 * @param {string} o.name      the lift
 * @param {string} o.unit      'kg' | 'lb'
 * @param {object} o.scheme    { startWeight, startReps, startRepsTo, steps: [{ percent, of, reps, repsTo }] }
 * @param {number} o.jump      the last warm-up jump
 * @param {number} o.emptyBar  the bar alone
 * @param {string} [o.kind]    'deadlift' starts at plate height, and says so
 * @param {number} [o.topSet]  today's top set, to print the weights it makes
 * @param {Array}  [o.sets]    the ramp for that top set ({ total, reps, repsTo })
 */
export function warmupsText({ name, unit, scheme, jump, emptyBar, kind, topSet, sets }) {
  const lines = [`${name} warm-ups · Work Up`, ''];

  const start = Number(scheme.startWeight) || 0;
  const startReps = times(scheme.startReps, scheme.startRepsTo);
  lines.push(start <= emptyBar
    ? `Empty bar × ${startReps}`
    : `First warm-up ${fmt(start)} ${unit}${kind === 'deadlift' ? ' (plate height)' : ''} × ${startReps}`);

  for (const s of scheme.steps ?? []) {
    lines.push(`${fmt(Number(s.percent) || 0)}% of the ${s.of === 'last' ? 'last warm-up' : 'top set'} × ${times(s.reps, s.repsTo)}`);
  }
  if (scheme.steps?.length) {
    lines.push(`Last warm-up: ${fmt(jump)} ${unit} under the top set × 1`);
    lines.push(`Each rounds to the nearest ${fmt(jumpRule(unit).step)} ${unit}.`);
  }

  if (topSet && sets?.length) {
    lines.push('', `For a ${fmt(topSet)} ${unit} top set:`);
    lines.push(sets.map((x) => `${fmt(x.total)} × ${times(x.reps, x.repsTo)}`).join(' · '));
  }
  return lines.join('\n');
}
